import { Controller } from "@hotwired/stimulus"
import { computePosition, flip, shift, offset } from "@floating-ui/dom"

export default class extends Controller {
  static targets = ["anchor", "menu"]

  connect() {
    this.hovered = false
  }

  open() {
    clearTimeout(this.closeTimeout)
    this.anchorTarget.setAttribute("aria-expanded", "true")
    this.menuTarget.togglePopover(true)
    this.#updatePosition()
    this.hovered = true
  }

  close() {
    this.closeTimeout = setTimeout(() => {
      if (!this.hovered) {
        this.anchorTarget.removeAttribute("aria-expanded")
        this.menuTarget.togglePopover(false)
      }
    }, 100)
    this.hovered = false
  }

  disconnect() {
    clearTimeout(this.closeTimeout)
  }

  async #updatePosition() {
    await new Promise(requestAnimationFrame)

    const { x, y } = await computePosition(this.anchorTarget, this.menuTarget, {
      placement: "right-start",
      strategy: "fixed",
      middleware: [
        offset(14),
        flip(),
        shift({ padding: 8 })
      ]
    })

    const paddingTop = parseFloat(getComputedStyle(this.menuTarget).paddingTop)

    Object.assign(this.menuTarget.style, {
      position: "fixed",
      left: `${x}px`,
      top: `${y - paddingTop}px`,
    })
  }
}
